module.exports = __webpack_public_path__ + "static/mobile-hero-simple-package-2b712f0bdc64f38dc57b5a81e5dc6214.jpg";